import SimpleModalInfo from 'lib/modal/simple-modal-info';
import { PStyled } from 'approot/shared/styles/typography.style';
import * as Styled from './teaching-learning-sequence-modal.style';
import {
  EVENT_TARGET_IDENTIFIER_TEACHING_LEARNING_SEQUENCE_ENRICHMENT_INFO,
  EVENT_TARGET_IDENTIFIER_TEACHING_LEARNING_SEQUENCE_CHECKPOINT_INFO,
} from 'approot/shared/data-tracker/data-events.constants';
import TeachingLearningSequenceInlineSvg from 'approot/shared/inline-svg/teaching-learning-sequence/teaching-learning-sequence-inline-svg';
import IconBlackDiamond from 'approot/shared/icons/icon-black-diamond';
import IconBlueSquare from 'approot/shared/icons/icon-blue-square';

type Props = {
  close: () => void;
};

export const TeachingLearningSequenceEnrichmentModal = ({ close }: Props) => {
  return (
    <SimpleModalInfo
      isVisible
      titleElement={
        <Styled.TeachingLearningSequenceModalHeader
          data-selector="modal-heading"
          textAlignCenter
        >
          Further Enrichment
          <IconBlueSquare width={18} height={18} />
          <IconBlackDiamond width={18} height={18} />
        </Styled.TeachingLearningSequenceModalHeader>
      }
      title="Further Enrichment"
      onClose={close}
      dataTracking={{
        label:
          EVENT_TARGET_IDENTIFIER_TEACHING_LEARNING_SEQUENCE_ENRICHMENT_INFO,
      }}
    >
      <PStyled>
        These are additional questions that can be used to further extend
        students who have mastered the core learning and successfully completed
        the deeper (blue square) and challenging (black diamond) questions
        within the main lesson. These can be found in the Extension Printables
        section.
      </PStyled>
    </SimpleModalInfo>
  );
};

export const TeachingLearningSequenceCheckpointModal = ({ close }: Props) => {
  return (
    <SimpleModalInfo
      isVisible
      titleElement={
        <Styled.TeachingLearningSequenceModalHeader data-selector="modal-heading">
          Checkpoint{' '}
          <TeachingLearningSequenceInlineSvg
            id="icon_star"
            width={18}
            height={18}
          />
        </Styled.TeachingLearningSequenceModalHeader>
      }
      title="Checkpoint"
      onClose={close}
      dataTracking={{
        label:
          EVENT_TARGET_IDENTIFIER_TEACHING_LEARNING_SEQUENCE_CHECKPOINT_INFO,
      }}
    >
      <PStyled>
        A checkpoint question is an opportunity for Formative Assessment.
      </PStyled>
    </SimpleModalInfo>
  );
};
